<div class="flex items-center justify-center">
  <div class="w-full max-w-lg py-5 mt-10 bg-white border rounded-lg border-100">
    <div class="px-8 border-b border-100">
      <h1 class="mb-4 text-lg font-semibold text-text-900">Buscar dentistas</h1>
    </div>

    <form [formGroup]="formsService.formPhysician" class="px-8">
      <app-address-selector
        [addresses]="userAddresses"
        [selectedAddressId]="formsService.formAddress.value.selectedAddress?.id"
        [currentAddressText]="getCompleteAddress() || 'Endereço'"
        (addressSelected)="selectAddress($event)"
        class="mt-4"
      />
      @let candidates = physiciansCandidates();
      @let hasCandidates = !!candidates?.physicians?.length;

      @if (candidates?.loading) {
        <div class="flex items-center justify-center py-8">
          <p class="text-sm text-text-700">
            Buscando dentistas de interesse...
          </p>
        </div>
      } @else if (candidates && hasCandidates) {
        <p class="text-sm text-text-700 font-semibold my-4">
          Dentistas selecionado pelo beneficiário
        </p>
        <div class="flex flex-col gap-4">
          @for (doctor of candidates.physicians; track doctor.physicianName) {
            <app-physician-card
              [name]="doctor.physicianName"
              [address]="getDoctorCompleteAddress(doctor)"
              [score]="doctor.score"
              [distance]="doctor.distanceInKilometers"
              [accredited]="doctor.accredited"
              (click)="selectDoctor(doctor, true)"
              (keydown.space)="selectDoctor(doctor, true)"
              tabindex="0"
              class="relative w-full p-4 transition-all border rounded-lg cursor-pointer hover:border-primary-500 hover:bg-primary-100/5"
              [ngClass]="{
                'bg-primary-100 bg-opacity-5 border-primary-500':
                  isSelected(doctor),
              }"
            />
          }
        </div>
        <app-divider class="my-8" />
      }

      @if (physicianSearchResult$ | async; as result) {
        @if (result.loading) {
          <div class="flex items-center justify-center py-8">
            <p class="text-sm text-text-700">Buscando dentistas...</p>
          </div>
        } @else if (result.physicians.length > 0) {
          @if (hasCandidates) {
            <p class="text-sm text-text-700 font-semibold">Outros dentistas</p>
          }

          <div class="flex flex-col gap-4 mt-4">
            @for (doctor of result.physicians; track doctor.physicianName) {
              <app-physician-card
                [name]="doctor.physicianName"
                [address]="getDoctorCompleteAddress(doctor)"
                [score]="doctor.score"
                [distance]="doctor.distanceInKilometers"
                [accredited]="doctor.accredited"
                (click)="selectDoctor(doctor)"
                (keydown.space)="selectDoctor(doctor)"
                tabindex="0"
                class="relative w-full p-4 transition-all border rounded-lg cursor-pointer hover:border-primary-500 hover:bg-primary-100/5"
                [ngClass]="{
                  'bg-primary-100 bg-opacity-5 border-primary-500':
                    isSelected(doctor),
                }"
              />
            }
          </div>
          <div class="w-full pt-4 mt-4">
            <app-paginator
              #paginator
              [totalRecords]="result.totalRecords"
              [first]="page() * rows()"
              [rows]="rows()"
              (pageChange)="onPageChange($event)"
            />
          </div>
        } @else {
          <div class="flex items-center justify-center py-8">
            <p class="text-sm text-gray-600">
              Nenhum dentista encontrado para este endereço.
            </p>
          </div>
        }
      }
    </form>
    <div class="w-full px-8 pt-4 mt-4 border-t border-border-100">
      <div class="grid grid-cols-2 gap-3 mt-2">
        <app-button
          label="Voltar"
          buttonType="secondary"
          buttonAction="default"
          (handleClick)="goBack()"
          fullSize="true"
        ></app-button>
        <app-button
          label="Avançar"
          buttonType="solid"
          buttonAction="default"
          [disabled]="!formsService.formPhysician.value.physicianId"
          (handleClick)="onGoNext()"
          fullSize="true"
        ></app-button>
      </div>
    </div>
  </div>
</div>
